export const DISCLAIMER_MODAL_SET_OPEN = 'DISCLAIMER_MODAL_SET_OPEN';
export const DISCLAIMER_MODAL_SHOW_CLOSE_BUTTON = 'DISCLAIMER_MODAL_SHOW_CLOSE_BUTTON';
